import React from 'react';
import '../user.css';
import { Image } from '@/components/Elements';
// import preview from '@/assets/preview.png';
import preview from '@/assets/backWal.png';
// import { useNotifications } from '@/api/Notification/getNotifications';
import { Notification } from '@/types';
import { timeFromNow } from '@/utils/format';
import clsx from 'clsx';

const NotifyAll = ({
  item,
  selected,
  onSelectItem,
}: {
  item: Notification;
  selected: string[];
  onSelectItem: (item: string) => void;
}) => {
  const handleClick = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
  };
  return (
    <>
      <div className={clsx('row notification', item.is_read == false ? 'unread' : 'read')}>
        <div className="col-md-2 col-xl-1 d-flex gap-1 items-center">
          <div className="setWidth">
            <input
              checked={selected.includes(item.id)}
              type="checkbox"
              onChange={() => onSelectItem(item.id)}
              onClick={handleClick}
              className="form-check-input"
            />
          </div>
          <div className="setWidthImg">
            <Image imagefallback={preview} className="itemImages" alt="banner" src={item.image} />
          </div>
          <div className="setWidthdot">
            {item.is_read == false ? <i className="fa-solid fa-circle notificationDot"></i> : null}
          </div>
        </div>
        <div className="col-12 col-md-8 col-xl-9 cntnt">{item.message}</div>
        <div className="col-12 col-md-2 dates dateSize f-13 text-end">{timeFromNow(item.date)} ago</div>
      </div>
    </>
  );
};

export default NotifyAll;
